import { render, staticRenderFns } from "./hbtdyszyxy.vue?vue&type=template&id=60bea4ba&scoped=true&"
import script from "./hbtdyszyxy.vue?vue&type=script&lang=js&"
export * from "./hbtdyszyxy.vue?vue&type=script&lang=js&"
import style0 from "./hbtdyszyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./hbtdyszyxy.vue?vue&type=style&index=1&id=60bea4ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bea4ba",
  null
  
)

export default component.exports